/* ILS — TASK-1704 — align suggest panel top to the ACTUAL header bottom.

   BUG (mobile, vp 390): when the user opens the suggest panel by FOCUSING the
   inline search input at the top of the page (TASK-1684 entry point), the
   panel's own "What are you looking for?" field is clipped from above. Same
   panel opened via the lens (after scroll-collapse) renders cleanly.

   ROOT CAUSE (measured 2026-06-23 via Playwright):
     - Panel is `position:fixed; top:68px` (TASK-1672) — designed for the
       collapsed layout where .shopify-section-ils-header-bar bottom = 68.
     - In the non-collapsed layout (page at top), the announcement bar
       (y=0..38) pushes the header-bar down to y=38..106. The panel still
       slots in at fixed top=68, so its top ~38px overlaps the bottom of
       the header bar.
     - On suggest-open, the header section z-index is bumped to 80
       (TASK-1672) so it stays bright above the backdrop. The panel
       sits at z=48 — well below — so the header bar paints OVER the
       overlap region and clips the panel's input.

   FIX (no CSS edits, no z-index war with the burger or the header bump):
     - When the panel opens, measure .shopify-section-ils-header-bar's real
       bottom in the viewport and write that as inline `top` (with the
       matching inset for the backdrop) on the panel + backdrop. The
       inline style trumps the CSS `top:68px !important` because inline
       beats stylesheet at the same `!important` priority.
     - Re-measure on scroll and resize while the panel is open so the
       panel follows the header as the page collapses / expands.
     - On close, clear the inline styles so the next open re-measures
       cleanly (and so the CSS default reasserts itself if anything
       depends on it).

   SCENARIO IMPACT:
     - A (lens after scroll-collapse): header-bar bottom = 68 → top=68px.
       Identical to current behaviour. Not broken.
     - B (inline-focus at top): header-bar bottom = 106 → top=106px.
       Panel drops below the visible header stack — input no longer clipped.
*/

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    var body = document.body;
    var headerBar = document.querySelector('.shopify-section-ils-header-bar');
    var panel = document.querySelector('.ils-suggest');
    var backdrop = document.querySelector('.ils-suggest__backdrop');

    if (!headerBar || !panel || !backdrop) return;

    function isOpen() {
      return body.classList.contains('ils-suggest-open');
    }

    function align() {
      // Header-bar is sticky top:0 — its bottom in the viewport is the lowest
      // point of the visible header stack we need to clear. Clamp to 0 in
      // case the bar somehow scrolls above the viewport.
      var bottom = Math.max(0, headerBar.getBoundingClientRect().bottom);
      var px = Math.round(bottom) + 'px';
      // setProperty with 'important' beats the stylesheet's !important at
      // the same priority level (inline > stylesheet for equal priority).
      panel.style.setProperty('top', px, 'important');
      backdrop.style.setProperty('top', px, 'important');
      backdrop.style.setProperty('inset', px + ' 0 0 0', 'important');
    }

    function clearAlignment() {
      panel.style.removeProperty('top');
      backdrop.style.removeProperty('top');
      backdrop.style.removeProperty('inset');
    }

    // Watch for the panel toggling open / closed via the body class.
    var obs = new MutationObserver(function () {
      if (isOpen()) align();
      else clearAlignment();
    });
    obs.observe(body, { attributes: true, attributeFilter: ['class'] });

    // Keep the panel aligned if the page reflows while the panel is open
    // (e.g. scroll causes ils-collapsed to toggle → header bottom moves).
    window.addEventListener('scroll', function () {
      if (isOpen()) align();
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (isOpen()) align();
    });

    // If a frame opens the panel synchronously before our observer fires
    // (unlikely, but cheap to be safe), do an initial pass.
    if (isOpen()) align();
  });
})();
